@if (loaded) {
  <section class="pt-5 d-flex justify-content-center centered">
    <div class="d-flex flex-column justify-content-center">
      <div class="card card-shadow mt-5">
        <div class="card-body">
          @if (errorMessage != null) {
            <div class="header-grid">
              <img src="assets/icons/redX.svg" data-testid="noIcon" />
              <div class="d-flex">
                <div class="d-flex justify-content-center flex-column">
                  <h3 class="fw-bold">Please upload a new file</h3>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <p>{{ errorMessage }}</p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12">
                <div class="d-flex justify-content-end">
                  <input type="file" id="uploadBtn4" hidden (change)="uploadFile($event)" />
                  <label class="btn btn-secondary me-2" for="uploadBtn4">
                    <img src="assets/icons/upload.svg" />
                    <span class="ms-2">Upload Timesheet</span></label
                  >
                  <button class="btn btn-primary" (click)="runPayroll(false)">
                    Continue to Payroll
                  </button>
                </div>
              </div>
            </div>
          } @else if (
            (isCsv == null || isCsv === true) && (meetsFileSize == null || meetsFileSize === true)
          ) {
            @if (selTimeclockFile != null && selTimeclockFile.Id != null) {
              <div class="header-grid">
                <img src="assets/icons/checkmark.svg" data-testid="icon" />
                <div class="d-flex">
                  <div class="d-flex justify-content-center flex-column">
                    <h3 class="fw-bold">Timeclock file found</h3>
                  </div>
                  <div class="d-flex justify-content-center flex-column ms-3">
                    <button
                      class="btn btn-secondary d-flex justify-content-between"
                      (click)="deleteFile()">
                      <span class="mt-auto mb-auto me-1"><i class="fas fa-file-csv"></i></span>
                      <span class="mt-auto mb-auto me-3">{{ selTimeclockFile.FileName }}</span>
                      <span class="mt-auto mb-auto"><img src="assets/icons/thin X.svg" /></span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <p data-testid="bodyText">
                    You have a pending timeclock file for the pay period ending on
                    {{ selTimeclockFile.PeriodEndDate | date: 'MM/dd/yyyy' }}. Would you like to use
                    it in your next payroll run?
                  </p>
                </div>
              </div>
              @if (selTimeclockFile.Messages != null && selTimeclockFile.Messages.length > 0) {
                <ul class="no-style mb-0 p-2 bg-grey timeclock-message-scroll-container">
                  @for (errors of selTimeclockFile.Messages; track $index) {
                    <li class="py-1">
                      <span
                        data-testid="warningErrorIcon"
                        class="pe-2 relay-icon"
                        [ngClass]="
                          errors.WarningLevel == WarningLevel['Critical']
                            ? 'relay-icon--error'
                            : 'relay-icon--warning'
                        ">
                      </span>
                      {{ errors.Message }}
                    </li>
                  }
                </ul>
              }
              <div class="row mt-5">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-secondary" (click)="runPayroll(false)">
                      Skip this Step
                    </button>
                    <button class="btn btn-primary ms-2" (click)="runPayroll(true)">
                      Use and Continue
                    </button>
                  </div>
                </div>
              </div>
            } @else if (fileRemoved) {
              <div class="row">
                <div class="col-12">
                  <h3 class="fw-bold">
                    Would you like to upload a new timesheet or continue to payroll?
                  </h3>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <p>You can save time by uploading an existing timesheet, if available.</p>
                </div>
              </div>
              <div class="row mt-5">
                <div class="d-flex justify-content-end">
                  <button class="btn btn-secondary me-2" (click)="undeleteFile()">Back</button>
                  <input type="file" id="uploadBtn" hidden (change)="uploadFile($event)" />
                  <label class="btn btn-secondary me-2" for="uploadBtn">
                    <img src="assets/icons/upload.svg" />
                    <span class="ms-2">Upload Timesheet</span></label
                  >
                  <button class="btn btn-primary" (click)="runPayroll(false)">
                    Continue to Payroll
                  </button>
                </div>
              </div>
            } @else if (
              (selTimeclockFile == null && timeclockFiles.length == 0) ||
              (selTimeclockFile?.Id == null &&
                selTimeclockFile?.Messages != null &&
                selTimeclockFile?.Messages.length > 0)
            ) {
              <div class="header-grid">
                <img src="assets/icons/redX.svg" data-testid="noIcon" />
                <div class="d-flex">
                  <div class="d-flex justify-content-center flex-column">
                    <h3 class="fw-bold">No Timeclock Files Found</h3>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <p data-testid="noBodyText">
                    We couldn't find a timeclock file for the period ending on
                    {{ pdis[0].PeriodEnd | date: 'MM/dd/yyyy' }}
                  </p>
                </div>
              </div>
              @if (selTimeclockFile?.Messages != null && selTimeclockFile?.Messages.length > 0) {
                <ul class="no-style mb-0 p-2 bg-grey timeclock-message-scroll-container">
                  @for (errors of selTimeclockFile.Messages; track $index) {
                    <li class="py-1">
                      <span
                        data-testid="warningErrorIcon"
                        class="pe-2 relay-icon"
                        [ngClass]="
                          errors.WarningLevel == WarningLevel['Critical']
                            ? 'relay-icon--error'
                            : 'relay-icon--warning'
                        ">
                      </span>
                      {{ errors.Message }}
                    </li>
                  }
                </ul>
              }
              <div class="row mt-5">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <input type="file" id="uploadBtn2" hidden (change)="uploadFile($event)" />
                    <label class="btn btn-secondary me-2" for="uploadBtn2">
                      <img src="assets/icons/upload.svg" />
                      <span class="ms-2">Upload Timesheet</span></label
                    >
                    <button class="btn btn-primary" (click)="runPayroll(false)">
                      Continue to Payroll
                    </button>
                  </div>
                </div>
              </div>
            } @else if (selTimeclockFile == null && timeclockFiles.length > 1) {
              <div>
                <div class="d-flex">
                  <div class="d-flex justify-content-center flex-column">
                    <h3 class="fw-bold">
                      Only one TimeClock file at a time can be imported into payroll.
                    </h3>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <span class="fw-bold">Please select the file you would like to use below:</span>
                </div>
                <div class="col-12">
                  <div class="radio-group d-flex flex-column">
                    @for (file of timeclockFiles; track file.Id) {
                      <div>
                        <input
                          type="radio"
                          [(ngModel)]="chosenTimeclockFile"
                          [value]="file"
                          [id]="'file_' + file.Id" />
                        <label [for]="'file_' + file.Id"
                          ><span></span> Schedule with period end
                          {{ file.PeriodEndDate | date: 'MM/dd/yyyy' }}</label
                        >
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <input type="file" id="uploadBtn5" hidden (change)="uploadFile($event)" />
                    <label class="btn btn-secondary me-2" for="uploadBtn5">
                      <img src="assets/icons/upload.svg" />
                      <span class="ms-2">Upload Timesheet</span></label
                    >
                    <button class="btn btn-secondary me-2" (click)="runPayroll(false)">
                      Skip this Step
                    </button>
                    <button
                      class="btn btn-primary"
                      (click)="runPayroll(true)"
                      [disabled]="chosenTimeclockFile == null">
                      Continue to Payroll
                    </button>
                  </div>
                </div>
              </div>
            }
          } @else {
            <div class="header-grid">
              <img src="assets/icons/redX.svg" data-testid="noIcon" />
              <div class="d-flex">
                <div class="d-flex justify-content-center flex-column">
                  <h3 class="fw-bold">Please upload a new file</h3>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                @if (!isCsv) {
                  <p>
                    This file type is not supported. Please upload a Timesheet in one of the
                    following formats (.csv)
                  </p>
                }
                @if (!meetsFileSize) {
                  <p>
                    The file you are trying to upload is too large (maximum size is
                    {{ maxFileSize }}MB)
                  </p>
                }
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12">
                <div class="d-flex justify-content-end">
                  <input type="file" id="uploadBtn3" hidden (change)="uploadFile($event)" />
                  <label class="btn btn-secondary" for="uploadBtn3">
                    <img src="assets/icons/upload.svg" />
                    <span class="ms-2">Upload Timesheet</span></label
                  >
                  <button class="btn btn-primary ms-2" (click)="runPayroll(false)">
                    Continue to Payroll
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </section>
}
